import * as React from 'react';
import classnames from 'classnames';

interface TextFieldProps {
    type: string;
    name: string;
    value: string;
    label: string;
    errorMessage: string;
    touchedValue: boolean;
    onBlur: (e: any) => void;
    onChange: (e: React.ChangeEvent<any>) => void;
    required?: boolean;
    col?: string;
    subLabel?: string;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
    min?: number;
    max?: number;
    onFocus?: () => void;
    helperText?: string;
}
const TextField: React.SFC<TextFieldProps> = ({
    type = ' text',
    name,
    value,
    label,
    subLabel,
    onBlur,
    disabled = false,
    onChange,
    onFocus,
    placeholder = '',
    touchedValue,
    errorMessage,
    className,
    col = '',
    required = false,
    min,
    max,
    helperText
}) => {
    return (
        <div
            className={classnames(`form-group ${col}`, {
                error: errorMessage && touchedValue
            })}
        >
            <label className="form-group__label form-group--block">
                {label} {subLabel && <i>({subLabel})</i>}
            </label>
            <input
                type={type || 'text'}
                name={name}
                placeholder={placeholder}
                onFocus={onFocus}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className={classnames('form-group__control', {
                    [className]: className
                })}
                disabled={disabled}
                required={required}
                min={min}
                max={max}
                autoComplete={name}
            />
            {(errorMessage && touchedValue && (
                <span className="form-group__error-msg">{errorMessage}</span>
            )) ||
                (helperText ? (
                    <span className="form-group__helper-msg">{helperText}</span>
                ) : (
                    <span
                        className="form-group__error-msg"
                        style={{ display: 'none', opacity: 0 }}
                    >
                        &nbps;
                    </span>
                ))}
        </div>
    );
};

export default TextField;
